var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dynamic_item", class: { hasMargin: _vm.hasMargin } },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "img_box" }, [
          _c("img", {
            attrs: {
              src: _vm.imgUrl,
              onerror:
                "this.src='//img.webloom.cn/img/logo/default-user.png';this.onerror=null",
              alt: ""
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "member" }, [
          _c("div", { staticClass: "name" }, [_vm._v(_vm._s(_vm.menber))]),
          _vm._v(" "),
          _vm.time
            ? _c("div", { staticClass: "time" }, [
                _vm._v(
                  _vm._s(
                    _vm.$utils.timestampToStr(new Date(_vm.time), "Y.M.D h:m")
                  )
                )
              ])
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "contant",
        domProps: { textContent: _vm._s(_vm.content) }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-e30c2f7e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-e30c2f7e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/team-homepage/DynamicItem.vue
// module id = null
// module chunks = 